import { FC } from "react";

import { useQuery } from "@tanstack/react-query";

import { getFeatureFlags } from "lib/v3/FeatureFlagsApi";

import LoadingScreen from "components/ui/LoadingScreen/LoadingScreen";

import FeatureFlagStoreContext from "./store";

import { useAuth } from "state";

const FeatureFlagManager: FC<{
  children: React.ReactNode;
}> = ({ children }): JSX.Element => {
  const { isLoggedIn } = useAuth();

  const { isLoading: isLoadingFeatureFlags } = useQuery(
    ["get-feature-flags"],
    () => getFeatureFlags(),
    {
      enabled: isLoggedIn,
      retryDelay: 1000,
      refetchOnMount: false,
      useErrorBoundary: false,
      onError() {
        console.error("Failed to fetch feature flags");
      },
      onSuccess(data) {
        FeatureFlagStoreContext.setState({
          flags: new Set(
            data.data.management_dashboard_feature_flags
              .filter((key) => key.enabled)
              .map((f) => f.key),
          ),
        });
      },
      retry: (failureCount) => failureCount <= 3,
    },
  );

  const isRenderBlocked = isLoggedIn && isLoadingFeatureFlags;

  if (isRenderBlocked) {
    return <LoadingScreen />;
  }

  return <>{children}</>;
};

export default FeatureFlagManager;
